<script setup lang="ts">
import { faMapPin } from '@fortawesome/pro-solid-svg-icons';
import { ReserveType } from '@utils/itinerary';
import type { Radio } from '#imports';
import SearchReserveForm from '@components/util/search/SearchReserveForm.vue';
import { SearchMode } from '@utils/types';

const { isChangeSearch, loading } = defineProps<{
    isChangeSearch?: boolean;
    loading?: boolean;
}>();
const hotelForm = useHotelForm();
const { isMobile } = useSize();
const dateSubmit = () => {
    if (isMobile.value) {
        form.onSubmit();
    }
};
const layoutStore = useLayoutStore();
const { inProcessFloatings } = classToRefs(layoutStore);
const form = useSearchForm(isChangeSearch);
const hotelOptions: Radio<SearchMode>[] = [
    {
        label: 'داخلی',
        value: SearchMode.Domestic,
    },
];
const searchHotelsAndCities = (search: string) => {
    hotelForm.searchTerm = search.replace('هتل', '').trim();
    hotelForm.searchLocations(search);
};

const formAlert = computed(() =>
    inProcessFloatings.value.length
        ? {
              title: `شما ${inProcessFloatings.value.length} شناوری فعال دارید`,
              href: `/reserve/floating?billCode=${inProcessFloatings.value[0].billCode}&mac=${inProcessFloatings.value[0].mac}`,
          }
        : undefined
);
onMounted(() => layoutStore.getFloatingsInProcess());
</script>

<template>
    <SearchReserveForm
        v-bind="form"
        :search-mode-options="hotelOptions"
        :is-change-search
        location-debounce-search
        destination-title="هتل یا شهر مقصد"
        :reserve-type="ReserveType.Hotel"
        :destination-icon="faMapPin"
        :loading
        destination-show-group-title
        :datepicker-options="{
            startTitle: 'ورود',
            endTitle: 'خروج',
            countNights: true,
            desktopInRow: true,
            disableJoined: true,
            forceRange: true,
            unequalRange: true,
        }"
        :form-alert
        :pax-picker-options="{ hidden: true }"
        @date-submit="dateSubmit"
        @search="searchHotelsAndCities"
    />
</template>
